export default "__VITE_ASSET__DFaFS_Fm__"